/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import { type ActionIconProps } from './types';

const stackItemIconStylesCompiled = css({
	display: 'inline-flex',
});

const ActionIcon = ({ testId, icon }: ActionIconProps): JSX.Element => {
	return (
		<span css={[stackItemIconStylesCompiled]} data-testid={`${testId}-icon`}>
			{icon}
		</span>
	);
};

export default ActionIcon;
